import * as React from 'react';

import { Badge, cn } from '@rematter/ui-web';
import { ThemeColor } from '@rematter/ui-web/types';

import { useTranslations } from '../../i18n/useTranslations';
import { ExecutionStatus } from '../../types';

type ExecutionStatusBadgeProps = {
  status: ExecutionStatus;
  size?: 'small' | 'xs' | 'default' | 'large';
  className?: string;
};

const statusColorMap: Record<ExecutionStatus, ThemeColor> = {
  Pending: 'neutral',
  Running: 'primary',
  WaitingApproval: 'warning',
  Completed: 'success',
  Failed: 'failure',
  Cancelled: 'neutral',
};

export const ExecutionStatusBadge: React.FC<ExecutionStatusBadgeProps> = ({
  status,
  size = 'small',
  className,
}) => {
  const t = useTranslations();
  const color = statusColorMap[status];

  return (
    <Badge
      color={color}
      size={size}
      className={cn('@ExecutionStatusBadge', className)}
    >
      {t.executionStatus[status]}
    </Badge>
  );
};
